// @flow
import tvgConf from "@tvg/conf";
import getProtocol from "../protocolSetter";
import requester from "../requester";

const seoService: string = "service.seo";
const getSeoServiceUrl = (): string => `${tvgConf().config(seoService)}`;

const getSeoData = (path: string): Promise<*> =>
  requester()({
    url: `${getProtocol()}${getSeoServiceUrl()}/metainfo?basepath=${path}`,
    method: "get",
    headers: { "x-tvg-context": tvgConf().context() }
  });

export default { getSeoData };
